var Popover = function Popover() {
  return {};
};

export default Popover;